type UserStatus = {
  isActive?: boolean;
};

export default function orderUsersByActiveStatus<T extends UserStatus>(users: T[]) {
  const activeUsers = users.filter((user) => user.isActive !== false);
  const inactiveUsers = users.filter((user) => user.isActive === false);

  return [...activeUsers, ...inactiveUsers];
}
